import React from 'react'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableContainer from '@material-ui/core/TableContainer'
import Header from './Header'
import Button from '@material-ui/core/Button'
import axios from 'axios'
import {Redirect} from 'react-router-dom'
import SignaturePad from 'react-signature-pad'

class CompleteRmaform extends React.Component
{

constructor(props)
{

    super(props)
    this.state={
       records:[],
       complaintid:'',
       complaintreply:'',
       success:'',
       redirect:false,
       signature1:'',
       errors:{}
    }
    this.signature2 = React.createRef()
}    
componentDidMount()
{
    const {match:{params}}= this.props
    this.setState({complaintid:params.cid})
    axios({method:'post',url:`https://www.thespiritofdubai.com/rmaform/php/fetchrecord.php?cid=${params.cid}`,
    mode:'no-core',
    withCredentials:false}).then((res)=>
    {
      
      this.setState({records:res.data})  
      this.setState({complaintreply:res.data[0]['complaintreply']})
      //alert(res.data[0]['complaintreply'])
     
    })
}
handleEnd=(data)=>{
    const signature= this.signature2
    this.setState({signature1:signature.current.toDataURL()})
}
handleChange=(e)=>
{
    this.setState({complaintreply:e.target.value})
}
handleSubmit=()=>
{
if(this.validateform())
{   
const postdata={
    signature1:this.state.signature1,
    complaintid:this.state.complaintid
}    
axios({
    method:"post",
    url:"https://www.thespiritofdubai.com/rmaform/php/complete.php",
    mode:"no-core",
    withCredentials:false,
    data:postdata

}).then((res)=>{
  // alert(res.data)
   this.setState({redirect:true})
   this.setState({success:'Record Saved Successfully'})

  
})
}
}
validateform()
{
   let formisvalid=true
   let errors={}
   
   if(!this.state.signature1)
   {
       formisvalid=false
       errors['cussignerr']='Please enter Signature'
   }
   this.setState({errors:errors})
   return formisvalid
}
render()
{
    const suc={
        color:"green"
    }
    const err={
        color:"#f00"
    }
    if(this.state.redirect)
    {
     return (<Redirect to="/view" />)
    }
     const IMG_PATH='https://www.thespiritofdubai.com/rmaform/php/upload/'
    
    return(
        <>
        <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12}>
        <form>  
         <input type='hidden' name='complaintid' value={this.state.complaintid} />  
         <input type="hidden" name='signature1' value={this.state.signature1} />   
        <TableContainer >
        <Table style={{width:"90%",margin:"auto"}}>
        <Header />
        <TableBody>
        <TableRow>
            <TableCell align="center" colSpan="2" style={{height:"20px"}}><h6><u>RETURN MERCHANDISE AUTHORIZATION</u></h6></TableCell>
            
        </TableRow>
        <TableRow>
    <TableCell style={suc} colSpan="2" align='center'>{this.state.success}</TableCell>

            </TableRow>
        <TableRow>
      
        
        {this.state.records.map(res=>
           <TableCell style={{width:"40%"}}>
           <Table style={{width:"100%"}} >
      
       <TableRow>
           <TableCell colSpan="2" style={{lineHeight:"10px"}}>
               <h5 style={{margin:"10px"}}>
               <u>SALES STAFF:</u>
               </h5></TableCell>
       </TableRow>
            <TableRow>
            <TableCell>
            Product : {res.productname}
            </TableCell>
            </TableRow>
             <TableRow>
             <TableCell>
             Location : {res.location}
             </TableCell>
         </TableRow>
         <TableRow>
            <TableCell>
            Sales Staff :{res.salestaff}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Invoice No# : {res.invoiceno}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Invoice Date :  {res.invoicedate}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Comments :  {res.comments}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{height:"300px"}}>
            &nbsp;
            </TableCell>
        </TableRow>
       

        </Table></TableCell>
        )}
 {this.state.records.map(res=>
        <TableCell style={{width:"40%"}} valign="top">
        <Table style={{width:"100%"}} >
   
    <TableRow>
        <TableCell colSpan="2" style={{lineHeight:"10px"}}>
            <h5 style={{margin:"10px"}}>
            <u>CUSTOMER:</u>
            </h5></TableCell>
    </TableRow>
    <TableRow>
            <TableCell>
            Ref : {res.rmaid}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Name : {res.customername}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Email : {res.email}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Phone : {res.phone}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Nature of Complaint :  {res.complaint}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Photo : <img src={`${IMG_PATH}`+`${res.image}`} width="100" height="auto" alt="RMA"/>
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Signature : <img src={res.signature} width="100" height="auto" alt="rma" />
           
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
           Complaint Reply :
            
            {this.state.complaintreply}
            </TableCell>
        </TableRow>
        </Table></TableCell>
 
        )}
    </TableRow>
        
    <TableRow>
           
      <TableCell style={{width:"100%"}} colSpan="2">
                <Table style={{width:"100%"}}>
              <TableRow>
        <TableCell  style={{width:"20%"}}>Signature</TableCell>
            <TableCell >
          
         
            <SignaturePad ref={this.signature2} clearButton={true} onEnd={this.handleEnd} />
            <div style={err}>{this.state.errors.cussignerr}</div> 
           
            </TableCell>
       </TableRow>
       </Table>
       </TableCell>
       </TableRow>

       <TableRow>
            <TableCell align="center" colSpan={2}>
                    <Button color='secondary' variant='contained' onClick={this.handleSubmit}>Submit</Button>
            </TableCell>
        </TableRow>            
               
    </TableBody>
    </Table>
    </TableContainer>  
    </form> 
    </Grid>     
    </Grid>
        </>
    )
}

}
export default CompleteRmaform